module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0116.jpg?v=f5f217be";